import { createStore } from 'vuex';
const modules: any = {};
const requireContext = require.context('./modules', false, /\.ts$/);

requireContext.keys().forEach((file) => {
    const moduleName = file.replace(/(\.\/|\.ts)/g, '');
    modules[moduleName] = requireContext(file).default;
});

export default createStore({
    state: {},
    getters: {},
    mutations: {},
    actions: {},
    modules
});
